import React, { PureComponent } from "react";
import FieldContainer from "../components/FieldContainer";
import { hasOriginalData } from "../utils";

export function formatData(value, format) {
  if (!format || !value) return value;
  switch (format) {
    case "uppercase":
      return value.toUpperCase();
    case "lowerCase":
      return value.toLowerCase();
  }
}

export default class StringField extends PureComponent {
  static defaultProps = {
    inputType: "text",
    value: "",
    required: false
  };

  render() {
    const { id, label, placeholder, name, inputType, format, value, onChange, required, disabled, locked } = this.props;
    if (disabled && !value) return null; // Hide disabled field
    return (
      <FieldContainer {...this.props}>
        <input
          id={id}
          className="af-string-field"
          name={name}
          type={inputType}
          placeholder={placeholder || label}
          value={value}
          required={required}
          readOnly={disabled || (locked && hasOriginalData(name))}
          onChange={e => onChange(name, e.target.value)}
          // onChange={e => onChange(name, formatData(e.target.value, format))}
        />
      </FieldContainer>
    );
  }
}
